import { FC, useCallback, useState } from 'react'

import { Warnings } from 'bank-bsa-reporting/src/routes/SAR/List/components'
import { Sars } from 'commons/types/DTO/bank/alerts/sars'
import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components/Layer'
import { PageSection, PageSectionFace } from 'ui/components/Page'
import { Table } from 'ui/components/Table'
import { useAlertsContext } from '~bank-alerts/context'

import { columns } from './columns'

export const SARsListTable: FC = () => {
  const { data, isTableLoading, onPageChange } = useAlertsContext()

  const {
    form: { SARsPage, SARsSize },
    showSARs,
    showSARsTotalCount
  } = data

  const [warnings, setWarnings] = useState<string | null>(null)

  const onShowWarnings = useCallback((warningsData: string) => setWarnings(warningsData), [])

  const onClose = useCallback(() => setWarnings(null), [])

  const handlePageChange = useCallback(
    (page: number, size: number) => {
      onPageChange(page, size, 'SARs')
    },
    [onPageChange]
  )

  return (
    <PageSection face={PageSectionFace.PRIMARY} title="SARs List" anchor="sar">
      <Warnings warnings={warnings} onClose={onClose} />
      <Layer rounded shadowed stretch>
        <Table<Sars>
          dataQa={TableDataQa.BP_ALERTS_SARS}
          columns={columns({ onShowWarnings })}
          dataSource={showSARs.map((el) => ({
            item: el
          }))}
          loading={isTableLoading('SARs')}
          pagination={{
            page: SARsPage || 1,
            size: SARsSize || 10,
            onChange: handlePageChange,
            total: showSARsTotalCount
          }}
        />
      </Layer>
    </PageSection>
  )
}
